import { useEffect, useState } from "react";
import { api } from "../lib/apiClient";
import { useAuth } from "../lib/auth";
import { useNavigate } from "react-router-dom";
import { Header, Footer } from "../components/Layout";
import { Users, FileText, Euro, TrendingUp } from "lucide-react";

export default function Admin() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (loading) return;
    if (!user) { navigate("/login"); return; }
    api.get("/admin/stats").then((r) => setStats(r.data)).catch((e) => setErr(e.response?.data?.detail || "Accès refusé"));
  }, [user, loading, navigate]);

  if (loading || !user) return <div className="min-h-screen flex items-center justify-center"><div className="pulse-dot"></div></div>;

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Header />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
        <div className="j-label mb-2">Dashboard Administrateur</div>
        <h1 className="j-h1 font-heading" data-testid="admin-title">Vue d'ensemble JurisIA</h1>

        {err && <div className="j-card mt-6 border-red-200 bg-red-50 text-red-700" data-testid="admin-error">{err}</div>}

        {stats && (
          <>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
              <Stat icon={<Users />} label="Utilisateurs" value={stats.total_users} testid="admin-users" />
              <Stat icon={<FileText />} label="Flashs générés" value={stats.total_cases} sub={`${stats.cases_by_mode.pro} pro · ${stats.cases_by_mode.citizen} citoyen`} testid="admin-cases" />
              <Stat icon={<Euro />} label="Revenu total" value={`${stats.revenue_eur.toFixed(2)} €`} sub={`${stats.paid_count} transactions`} testid="admin-revenue" />
              <Stat icon={<TrendingUp />} label="MRR SaaS" value={`${stats.mrr_eur.toFixed(2)} €`} sub={`Conv. ${stats.conversion_rate_pct}%`} testid="admin-mrr" />
            </div>

            <div className="j-card mt-6">
              <h2 className="font-heading font-black text-lg mb-4">Revenu par produit</h2>
              {Object.keys(stats.revenue_by_key_eur).length === 0 && <div className="text-slate-500 text-sm">Aucune transaction payée pour l'instant.</div>}
              <div className="space-y-2">
                {Object.entries(stats.revenue_by_key_eur).map(([k, v]) => (
                  <div key={k} className="flex justify-between items-center py-2 border-b border-slate-100 last:border-0" data-testid={`admin-key-${k}`}>
                    <span className="font-heading text-sm">{k}</span>
                    <span className="font-black text-[#10B981]">{v.toFixed(2)} €</span>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}

function Stat({ icon, label, value, sub, testid }) {
  return (
    <div className="j-card" data-testid={testid}>
      <div className="j-label mb-2 flex items-center gap-2">{icon} {label}</div>
      <div className="font-heading font-black text-3xl text-[#1E293B]">{value}</div>
      {sub && <div className="text-xs text-slate-500 mt-1">{sub}</div>}
    </div>
  );
}
